module.exports = __webpack_public_path__ + "static/media/cswap-emblem-silver.599d5487.svg";